const accessReviewTutorial = {
  module: 'access_review',
  moduleName: 'Access Review',
  steps: [
    { target: '.page-title', position: 'bottom', title: 'Access Review', description: 'Periodic review and certification of user access rights.' },
    { target: '.btn-primary', position: 'bottom', title: 'Certify', description: 'Confirm that current access levels are still appropriate.' },
  ],
};
export default accessReviewTutorial;
